import styled from 'styled-components'
import {Link} from 'react-router'
import {spacing} from '../../../../../theme/spacing'

export const Logo = styled(Link)`
    display: block;
    margin-right: ${spacing(10)};
    width: 214px;
    height: 46px;
`
